export const useMultigetDeboucePost = createUseAbstractionDebounce(() => useApollo('post'))
export const useMultigetDebouceGet = createUseAbstractionDebounce(() => useApollo('get'))
